import { motion } from "framer-motion";
import { ReactNode } from "react";

interface AnimatedCardProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  hoverScale?: number;
}

export const AnimatedCard = ({
  children,
  className = "",
  delay = 0,
  hoverScale = 1.02,
}: AnimatedCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{
        duration: 0.5,
        delay,
        ease: [0.25, 0.1, 0.25, 1],
      }}
      whileHover={{
        scale: hoverScale,
        transition: { duration: 0.2 },
      }}
      className={className}
      layout={false}
    >
      {children}
    </motion.div>
  );
};
